import { useTranslation } from 'react-i18next'

import { CommunityHighlightRoom } from '../CommunityHighlightRoom'

import styles from './CommunityRoomsNavHighlights.module.scss'

export const CommunityRoomsNavHighlights = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div className={styles.label}>{t('events.highlights.label')}</div>
      <div className={styles.inlineList}>
        <CommunityHighlightRoom
          name={t('communities.highlights.info')}
          iconVariant="info"
          path="info"
        />
        <CommunityHighlightRoom
          name={t('communities.highlights.members')}
          iconVariant="members"
          path="members"
        />
      </div>
    </div>
  )
}
